var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plus",
    clipPath: "url(#clip0_44_2212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.2222 6.22222H7.77778V0.777778C7.77778 0.571498 7.69583 0.373667 7.54997 0.227806C7.40411 0.0819442 7.20628 0 7 0C6.79372 0 6.59589 0.0819442 6.45003 0.227806C6.30417 0.373667 6.22222 0.571498 6.22222 0.777778V6.22222H0.777778C0.571498 6.22222 0.373667 6.30417 0.227806 6.45003C0.0819442 6.59589 0 6.79372 0 7C0 7.20628 0.0819442 7.40411 0.227806 7.54997C0.373667 7.69583 0.571498 7.77778 0.777778 7.77778H6.22222V13.2222C6.22222 13.4285 6.30417 13.6263 6.45003 13.7722C6.59589 13.9181 6.79372 14 7 14C7.20628 14 7.40411 13.9181 7.54997 13.7722C7.69583 13.6263 7.77778 13.4285 7.77778 13.2222V7.77778H13.2222C13.4285 7.77778 13.6263 7.69583 13.7722 7.54997C13.9181 7.40411 14 7.20628 14 7C14 6.79372 13.9181 6.59589 13.7722 6.45003C13.6263 6.30417 13.4285 6.22222 13.2222 6.22222Z",
    fill: "#6651BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_2212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.7b86d4bb1f3d59716dfc4d5352bac808.svg";
export { ForwardRef as ReactComponent };